export const LOAD_CONTENT = 'hg/addon/LOAD_CONTENT';

export const loadContent = (addOnType) => {
  return {
    type: LOAD_CONTENT,
    addOnType
  };
};



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/MyPlan/addOn/addOn.js
 **/